module.exports = __webpack_public_path__ + "img/suv.9944a428.svg";